<template>
  <DetailsUser :userId="userId" />
  <CoursesUser :userId="userId" />
</template>

<script>
import DetailsUser from '@/components/users/DetailsUser.vue'
import CoursesUser from '@/components/users/CoursesUser.vue'

export default {
  name: 'UserDetails',

  components: {
    DetailsUser,
    CoursesUser,
  },

  data() {
    return {
      userId: this.$route.params.userId,
    }
  },
}
</script>
